import { useContext } from "react";
import { SSRContext } from "lib/providers/ssrProvider";

export const useIsSSR = (): boolean => useContext(SSRContext);
